(function($) {

    $heroSlider = $(".hero-slider");
    $heroNavItems = $('.hero-slider-nav-item');
    let has_animated = false;

    $heroSlider.slick({
        arrows: false,
        dots: false,
        draggable: true,
        fade: true,
        rows: 0,
    });

    $(".hero-slider-nav-item[data-slide='1']").addClass('active');

    if($('body').hasClass('home')) {
        $(".hero-slide video.hero-background").on('ended', function() {
            $heroSlider.slick('slickGoTo', 1);
            $heroNavItems.children('.indicator').removeClass('active');
            $heroNavItems.removeClass('active');
            $(".hero-slider-nav-item[data-slide='2']").children(".indicator").addClass('active');
            $(".hero-slider-nav-item[data-slide='2']").addClass('active');
            animateSequence();
        });

        $(".skip-intro").on("click", function() {
            $(this).hide();
            $(".main-nav").fadeIn(750);
            $(".hero-slider-nav").fadeIn(750);
            $(".hero-slider-nav-item").fadeIn(750);
            $heroSlider.slick('slickGoTo', 1);
            $heroNavItems.children('.indicator').removeClass('active');
            $(".hero-slider-nav-item[data-slide='2']").children(".indicator").addClass('active');
            $(".hero-slider-nav-item[data-slide='2']").addClass('active');
            animateSequence();
        })
    }

    $heroNavItems.on("click", function (e) {
        $heroNavItems.removeClass('active');
        $heroNavItems.children('.indicator').removeClass('active');
        $(this).children('.indicator').addClass('active');
        $(this).addClass('active');
        e.preventDefault();
        var slideno = $(this).data('slide');
        $heroSlider.slick('slickGoTo', slideno - 1);
        animateSequence();
    });

    function animateSequence() {
        if (!has_animated) {
            var a = document.getElementsByClassName('hero-sequence-top');
            var b = document.getElementsByClassName('hero-sequence-bottom');
            for (var i = 0; i < a.length; i++) {
                var $this = a[i];
                var letter = $this.innerHTML;
                letter = letter.trim();
                var str = '';
                var delay = 30;
                for (l = 0; l < letter.length; l++) {
                    if (letter[l] != ' ') {
                        str += '<span style="animation-delay:' + delay + 'ms;' +
                            '-moz-animation-delay:' + delay + 'ms;' +
                            ' -webkit-animation-delay:' + delay + 'ms; ">' + letter[l] + '</span>';
                        delay += 30;
                    } else {
                        str += letter[l];
                    }
                }
                $this.innerHTML = str;
            }
            for (var i = 0; i < b.length; i++) {
                var $this = b[i];
                var letter = $this.innerHTML;
                letter = letter.trim();
                var str = '';
                var delay = 600;
                for (l = 0; l < letter.length; l++) {
                    if (letter[l] != ' ') {
                        str += '<span style="animation-delay:' + delay + 'ms;' +
                            '-moz-animation-delay:' + delay + 'ms;' +
                            ' -webkit-animation-delay:' + delay + 'ms; ">' + letter[l] + '</span>';
                        delay += 60;
                    } else {
                        str += letter[l];
                    }
                }
                $this.innerHTML = str;
            }
            has_animated = true;
        }
    }
})( jQuery );